import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { X, Check } from "lucide-react";

interface DepositPaymentDetails {
    destinationCustomerAccount?: string;
    transactionAmount?: number;
    transactionFee?: number;
    currency?: string;
}

interface ConfirmDepositPaymentDialogProps {
    depositPaymentDetails: DepositPaymentDetails;
    isSubmitting: boolean;
    onSubmit: () => void;
    onHide: () => void;
    visible: boolean;
}

export const ConfirmDepositPaymentDialog: React.FC<ConfirmDepositPaymentDialogProps> = ({
    depositPaymentDetails,
    isSubmitting,
    onSubmit,
    onHide,
    visible
}) => {

	const formatBalance = (amount: any, currencyCode: any) => {
		const formattedAmount = parseFloat(amount).toLocaleString("en-US", {
			style: "currency",
			currency: currencyCode,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		const currency = formattedAmount.replace(/[\d.,]/g, "").trim();
		const amountWithoutCurrency = formattedAmount.replace(currency, "").trim();
		return `${amountWithoutCurrency} ${currency}`;
	};

    const renderFooter = () => {
        return (
            <div className="flex justify-content-end gap-2">
                <Button
                    label={"Cancel"}
                    icon={<X size={16} />}
                    onClick={onHide}
                    text
                />
                <Button
                    label={"Proceed"}
                    icon={<Check size={16} />}
                    onClick={onSubmit}
                    loading={isSubmitting}
                    autoFocus
                />
            </div>
        );
    };

    return (
        <Dialog
            header={"Deposit Payment"}
            visible={visible}
            style={{ width: '450px' }}
            onHide={onHide}
            footer={renderFooter()}
            closable={!isSubmitting}
            dismissableMask={!isSubmitting}
        >
            <div className="flex flex-column gap-3">
                <div className="flex justify-content-between align-items-center">
                    <span className="font-semibold">{"Source Account"}:</span>
                    <span className="text-sm">
                        {depositPaymentDetails.destinationCustomerAccount ?? "-"}
                    </span>
                </div>

                <div className="flex justify-content-between align-items-center">
                    <span className="font-semibold">{"Amount"}:</span>
                    <span className="font-bold">
                        {depositPaymentDetails.transactionAmount != null && depositPaymentDetails.currency != null
                            ? formatBalance(depositPaymentDetails.transactionAmount, depositPaymentDetails.currency)
                            : "-"}
                    </span>
                </div>

                <div className="flex justify-content-between align-items-center">
                    <span className="font-semibold">{"Transaction Fee"}:</span>
                    <span className="font-bold">
                        {depositPaymentDetails.transactionFee != null && depositPaymentDetails.currency != null
                            ? formatBalance(depositPaymentDetails.transactionFee, depositPaymentDetails.currency)
                            : "-"}
                    </span>
                </div>
            </div>
        </Dialog>
    );
}; 